import { Loader2 } from "lucide-react"

export const LoaderElement = () => {
  return (
    <div className="flex items-center justify-center py-24">
      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
    </div>
  )
}